<template>
  <!-- <div
      v-if="$store.state.hasLoginCookie || $auth.loggedIn"
      style="height: 100%"
      :class="{
        'center-flex':
          pagination.count !== null &&
          classes.length == 0 &&
          $auth.user.account_type !== 's',
      }"
    > -->
  <div style="height: 100%">
    <logged-out v-if="!$auth.loggedIn" />

    <div v-else-if="$auth.loggedIn" class="pt-12">
      <v-alert
        v-if="$device.isMobile"
        border="bottom"
        colored-border
        type="warning"
      >
        {{ $t('errors.mobile_cannot_create') }}
      </v-alert>
      <client-only> 
        <v-alert
            v-if="$i18n.locale === 'en' && $auth.user && !$auth.user.is_student"
          color="primary"
          type="info"
        >
          <v-row align="center">
            <v-col class="grow py-0">
              Are you a US K-12 educators or librarian ? Join us for our free
              summer professional development course!
            </v-col>
            <v-col class="shrink py-0">
              <v-btn
                target="_blank"
                to="/pathfinders-summer-pd-2025/"
                color="white"
                light
              >
                Learn More
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </client-only>
      <!-- <school-dashboard
        v-if="$auth.user && $auth.user.account_type == 'o'"
      />
      <v-container v-else class="main-container">
        <div>
          <v-layout justify-center>
            <div class="width-280 hidden-md-and-down">
              <user-card v-if="$auth.user" :user="$auth.user" />
              <badges-list v-if="$auth.user" />
            </div>
            <div id="homeActivityFeed" class="width-690">
              <display-message v-if="$auth.user" />
              <activity-feed v-if="$auth.user" />
            </div>
            <div class="width-300 ml-2 hidden-md-and-down">
              <v-card class="mb-2">
                <suggested-users v-if="$auth.user" />
              </v-card>
            </div>
          </v-layout>
        </div>
      </v-container> -->

      <school-dashboard v-if="$auth.user && $auth.user.account_type == 'o'" />
      <v-container v-else>

        <hello-user
          v-if="$auth.user.is_student"
          :user="$auth.user"
        />
        <div v-if="classes.length > 0 || $auth.user.is_student">
          <v-layout class="mt-5 mb-6 px-0" align-center justify-content-center>
            <h3 class="mb-0" style="color: #7b7b7b; font-weight: 300">
              {{ $t('classroom.selectClass') }}
            </h3>

            <v-spacer></v-spacer>

            <v-btn
              v-if="$auth.user && $auth.user.is_student"
              color="primary"
              outlined
              @click="joinClassDialog = true"
            >
              {{ $t('navbar.signup.form.join_classroom_title') }}
            </v-btn>
            <v-switch
              v-if="
                $auth.user &&
                !$auth.user.is_student &&
                $vuetify.breakpoint.mdAndUp
              "
              v-model="showAll"
              :hide-details="true"
              :label="$t('classroom.showAll')"
              class="mr-6"
              style="margin-top: 21px; flex: 0 1 auto; margin: 0; padding: 0"
            />

            <v-btn
              v-if="$auth.user && !$auth.user.is_student"
              depressed
              color="accent"
              class="ma-0"
              @click="addNewClassDialog()"
            >
              <v-icon size="27" style="display: block; width: 100%">
                $vuetify.icons.mdiPlus
              </v-icon>
              <span v-if="$vuetify.breakpoint.mdAndUp">
                {{ $t('classroom.createClass') }}
              </span>
            </v-btn>
          </v-layout>

          <v-layout class="classGrid" row wrap style="min-height: 300px">
            <!-- <v-flex class="pa-3" lg3 md4 sm6 xs12>
            <v-btn
              id="addClassBtn"
              depressed
              color="white"
              style="border: 2px dashed #b6b6b6 !important;height: 100%;"
              @click="createClassDialog = true"
            >
              <v-icon size="50" style="display:block;width: 100%;"
                >$vuetify.icons.mdiPlus</v-icon
              >
              {{ $t('classroom.createClass') }}
            </v-btn>
          </v-flex> -->
            <v-flex
              v-for="(el, index) in classes"
              v-show="showAll || !el.archived_at"
              :key="index"
              class="pa-3"
              lg3
              md4
              sm6
              xs12
            >
              <class-card
                :classroom="el"
                :is-select="$auth.user && $auth.user.is_student"
              />
            </v-flex>
          </v-layout>
        </div>

        <div
          v-if="
            pagination.count !== null &&
            classes.length == 0 &&
            !$auth.user.is_student
          "
        >
          <v-layout
            wrap
            align-center
            :class="{ 'column-reverse': $vuetify.breakpoint.smAndDown }"
          >
            <v-flex xs12 sm12 md6>
              <div style="max-width: 400px">
                <h4>
                  {{ $t('home_page.message.welcome.title') }}
                </h4>
                <p>
                  {{ $t('home_page.message.welcome.subtitle') }}
                </p>
                <v-layout>
                  <v-btn depressed color="accent" @click="addNewClassDialog()">
                    <v-icon size="27" style="display: block; width: 100%">
                      $vuetify.icons.mdiPlus
                    </v-icon>
                    <span>{{ $t('classroom.createClass') }}</span>
                  </v-btn>
                  <v-btn depressed @click="joinClassDialog = true" class="ml-2">
                    {{ $t('navbar.signup.form.join_classroom_title') }}
                  </v-btn>
                </v-layout>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md6 class="mb-6">
              <v-img src="/img/genie.png" class="home-genie-img"></v-img>
            </v-flex>
          </v-layout>
        </div>

        <div
          v-if="
            ((pagination.count == null && pagination.next == null) ||
              pagination.next != null) &&
            showLoading
          "
          v-observe-visibility="{ callback: loadMore, throttle: 600 }"
        >
          <p style="color: #bbb; padding-top: 10px; text-align: center">
            Loading ...
          </p>
        </div>
      </v-container>
      <v-dialog
        v-model="createClassDialog"
        scrollable
        :fullscreen="$vuetify.breakpoint.xsOnly"
        class="btn-dialogue"
        width="500"
      >
        <v-card>
          <v-card-title class="blue-purple-gradient">
            <span>{{ $t('classroom.createClass') }}</span>
            <v-spacer></v-spacer>
            <v-btn class="ma-0" text icon @click="createClassDialog = false">
              <v-icon color="white">$vuetify.icons.mdiClose</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <class-form
              :is-create="true"
              scope="create-class-form"
              class="pa-3"
              @createClass="onCreateClass"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- CHANGE PLAN DIALOG -->
      <v-dialog
        v-model="changePlanDialog"
        max-width="500"
        persistent
        :fullscreen="$vuetify.breakpoint.xsOnly"
      >
        <educator-upgrade
          @closeDialog="closeChangePlanDialog"
          header="Upgrade to create unlimited classes"
        />
      </v-dialog>

      <v-dialog
        v-model="joinClassDialog"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        persistent
        width="400"
      >
        <v-card>
          <v-card-title class="blue-purple-gradient">
            {{ $t('navbar.signup.form.join_classroom_title') }}
            <v-spacer />
            <v-btn class="ma-0" text icon @click="closeJoinClassDialog()">
              <v-icon color="white">$vuetify.icons.mdiClose</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="padding-top: 24px">
            <v-row style="align-items: center">
              <v-container>
                <v-alert
                  v-if="!$auth.user.is_student"
                  type="error"
                  max-width="400px"
                  style="margin: 0 auto; margin-bottom: 65px"
                >
                  {{ $t('navbar.signup.form.join_classroom_warning') }}
                </v-alert>
                <v-card width="400px" outlined style="margin: 0 auto">
                  <v-card-title>
                    {{ $t('navbar.signup.form.join_classroom_title') }}
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <join-class-form
                      :join-class="true"
                      @joined-classroom="onJoinedClassroom"
                    />
                  </v-card-text>
                </v-card>
                <not-user-footer />
                <div
                  v-if="$auth.user.is_student"
                  class="text-center"
                  style="font-size: 13px; margin-top: 10px"
                >
                  Not a student?
                  <nuxt-link :to="localePath('/settings/')">
                    Change your account type.
                  </nuxt-link>
                </div>
              </v-container>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
  import LoggedOut from '~/components/home/LoggedOut'
  export default {
    components: {
      LoggedOut,
      ClassForm: () => import('~/components/forms/ClassForm.vue'),
      EducatorUpgrade: () =>
        import('~/components/utils/upgrade/EducatorUpgrade'),
      classCard: () => import('@/components/classes/ClassCard.vue'),
      HelloUser: () => import('~/components/utils/HelloUser.vue'),
      NotUserFooter: () => import('~/components/classes/NotUserFooter.vue'),
      'school-dashboard': () => import('~/components/schools/MainDashboard'),
      'join-class-form': () =>
        import('~/components/forms/classroom/JoinClassForm')
    },
    head() {
      return {
        title: this.$t('meta.index.title'),
        meta: [
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content: this.$t('meta.index.description')
          },

          // Open Graph
          {
            hid: 'og:title',
            name: 'og:title',
            content: this.$t('meta.index.title')
          },
          {
            hid: 'og:description',
            name: 'og:description',
            content: this.$t('meta.index.description')
          },
          {
            hid: 'og:url',
            property: 'og:url',
            content: 'https://elementari.com' + this.$route.path
          }
        ],
        link: [
          {
            rel: 'preload',
            href: '/img/website/AASL.webp',
            as: 'image'
          },
          {
            rel: 'preload',
            href: '/img/website/commonsense.webp',
            as: 'image'
          },
          {
            rel: 'preload',
            href: '/img/website/Student Privacy Pledge Sig_logo.webp',
            as: 'image'
          }
        ]
      }
    },
    data() {
      return {
        active: 0,
        classes: [],
        showAll: false,
        showPasscode: false,
        createClassDialog: false,
        changePlanDialog: false,
        joinClassDialog: false,
        pagination: {
          page: 1,
          count: null,
          next: null,
          previous: null
        },
        showLoading: true
      }
    },
    computed: {
      isLoggedIn() {
        return !!this.$auth.user
      }
    },
    watch: {
      isLoggedIn(newVal, oldVal) {
        if (!newVal && oldVal) {
          this.classes = []
          this.showAll = false
          this.showLoading = true
          this.pagination = {
            page: 1,
            count: null,
            next: null,
            previous: null
          }
        }
      }
    },
    async mounted() {
      if (
        this.$route.query.join &&
        this.$auth.user &&
        this.$auth.user.is_student
      ) {
        this.joinClassDialog = true
      }
      if (
        this.$auth.user &&
        this.$auth.user.is_student &&
        !this.$auth.user.student_data.has_classroom
      ) {
        this.joinClassDialog = true
      }
    },
    methods: {
      addNewClassDialog() {
        if (this.classes.length > 0 && this.$auth.user.account_type === null) {
          this.changePlanDialog = true
          return
        }
        this.createClassDialog = true
      },
      closeChangePlanDialog() {
        this.changePlanDialog = false
      },
      async loadMore() {
        try {
          this.showLoading = false
          let res
          if (this.$auth.user.is_student) {
            res = await this.$api.getStudentClassrooms(
              this.$auth.user.username,
              this.pagination.page
            )
            res = res.data
          } else {
            res = await this.$api.getClassrooms(
              this.$auth.user.username,
              this.pagination.page
            )
          }

          this.pagination.count = res.count
          this.pagination.next = res.next
          if (this.pagination.next) {
            this.pagination.page++
          }
          this.classes = this.classes.concat(res.results)
          this.showLoading = true
        } catch (e) {
          console.log(e)
        }
      },
      onCreateClass(data) {
        this.createClassDialog = false
        this.$router.push(this.localePath('/classes/' + data.slug + '/'))
      },
      closeJoinClassDialog() {
        this.joinClassDialog = false
      },
      onJoinedClassroom(classroom) {
        this.classes.push(classroom)
        this.joinClassDialog = false
        this.$toast.success(this.$i18n.t('toast.form_success'), {
          theme: 'bubble',
          duration: 5000
        })
      }
    }
  }
</script>

<style scoped>
  @media only screen and (min-width: 960px) {
    .container {
      max-width: none;
    }
    #homeActivityFeed {
      margin-left: 0.5rem;
    }
  }
  .class-card-gradient {
    background-image: radial-gradient(
      circle farthest-corner at 6.4%,
      at 9.8%,
      rgba(88, 242, 174, 1) 0%,
      rgba(0, 130, 240, 1) 97.9%
    );
    background-image: radial-gradient(
      circle farthest-corner at 6.4% 9.8%,
      rgba(88, 242, 174, 1) 0%,
      rgba(0, 130, 240, 1) 97.9%
    );
    color: white;
  }

  @media (min-width: 960px) {
    .container {
      max-width: 900px;
    }
  }
  @media (min-width: 1264px) {
    .container {
      max-width: 1185px;
    }
  }
  @media (min-width: 1904px) {
    .container {
      max-width: 1785px;
    }
  }

  .column-reverse {
    flex-direction: column-reverse;
  }

  .home-genie-img {
    width: 60%;
    margin: auto;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  @media only screen and (min-width: 600px) {
    .home-genie-img {
      width: 80%;
    }
  }
  .center-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
